import React from "react"

import { MobileSwapWrapper } from "./styles"

import Header from "../header"
import Heading from "../heading"
import Text from "../text"
import Code from "../code"
import Subnavigation from "../subnavigation"
import Summary from "../summary"
import Blockquote from "../blockquote"
import Pullquote from "../pullquote"
import List from "../list"
import Image from "../image"
import Gallery from "../gallery"
import TextAndImage from "../text-and-image"
import Video from "../video"
import Embed from "../embed"
import Shop from "../shop"
import Footer from "../footer"
import Recipe from "../recipe"
import EnhancedList from "../enhanced-list"
import Review from "../review"
import Equipment from "../equipment"
import Product from "../product"
import InlineAd from "../ads/inline-ad"
import InlineContentfulAd from "../ads/inline-contentful-ad"
import HeadingAccordion from "../heading-accordion"
import Table from "../table"
import ProductReviewQuickList from "../product-review-quick-list"
import ProductReview from "../product-review"
import PromotionalPlacement from "../promotional-placement"

const Element = ({
  article,
  contentfulAdUnits,
  element,
  showAds,
  inlineAdIndex,
  background,
  setBottomStickyProduct,
  index,
  elementsLength,
  articleElementsLength,
}) => {
  const { elements, bodyFontColor, template } = article

  if (index === elementsLength - 1 && element.type === "ad") {
    return null
  }
  const isPremium = template === "premium"
  const isClean = template === "clean"
  const bodyFont = isPremium ? bodyFontColor : ""

  // we are using a render fuction because we need to call it recursively in some cases
  const renderElement = (element) => {
    const { type } = element

    let Component = null

    switch (type) {
      case "header": {
        const subnavigation = elements.find((el) => el.type === "subnavigation")
        Component =
          isPremium || isClean ? null : (
            <Header article={article} element={element}>
              {subnavigation ? <Subnavigation article={article} element={subnavigation} /> : null}
            </Header>
          )
        break
      }
      case "heading":
        Component = element.accordion ? (
          <HeadingAccordion element={element} background={background}>
            {element.content?.map((el) => (
              <span key={`element-${el.uuid}`}>{renderElement(el)}</span>
            ))}
          </HeadingAccordion>
        ) : (
          <Heading element={element} />
        )
        break
      case "text":
      case "introduction":
        Component = <Text element={element} fontColor={bodyFont} />
        break
      case "code":
        Component = <Code element={element} />
        break
      case "ad":
        Component = showAds ? (
          <InlineAd
            article={article}
            element={element}
            inlineAdIndex={inlineAdIndex}
          />
        ) : null
        break
      case "contentful-ad":
        Component = showAds ? <InlineContentfulAd element={element} /> : null
        break
      case "promotional-placement":
        Component = <PromotionalPlacement article={article} element={element} />
        break
      case "summary":
        Component = <Summary element={element} />
        break
      case "blockquote":
        Component = <Blockquote element={element} />
        break
      case "pullquote":
        Component = <Pullquote element={element} />
        break
      case "list":
        Component = <List element={element} />
        break
      case "image":
        Component = <Image element={element} />
        break
      case "gallery":
        Component = <Gallery element={element} />
        break
      case "text-and-image":
        Component = <TextAndImage element={element} />
        break
      case "video":
        Component = <Video element={element} />
        break
      case "embed":
        Component = <Embed element={element} />
        break
      case "shop":
        Component = <Shop article={article} element={element} />
        break
      case "footer":
        Component = <Footer element={element} />
        break
      case "recipe":
        Component = <Recipe article={article} element={element} />
        break
      case "review":
        Component = (
          <Review
            article={article}
            contentfulAdUnits={contentfulAdUnits}
            element={element}
            showAds={showAds}
            inlineAdIndex={inlineAdIndex}
          />
        )
        break
      case "equipment":
        Component = <Equipment element={element} />
        break
      case "enhanced-list":
        Component = <EnhancedList element={element} />
        break
      case "product":
        Component = (
          <Product
            element={element}
            setBottomStickyProduct={setBottomStickyProduct}
            isLastElement={index === articleElementsLength - 1}
            isPreLastElement={index === articleElementsLength - 2}
          />
        )
        break
      case "product-and-text":
        Component = (
          <MobileSwapWrapper>
            <Product
              element={element.product}
              setBottomStickyProduct={setBottomStickyProduct}
              inline
              isLastElement={index === articleElementsLength - 1}
              isPreLastElement={index === articleElementsLength - 2}
            />
            <Text element={element.text} fontColor={bodyFont} />
          </MobileSwapWrapper>
        )
        break
      case "table":
        Component = <Table element={element} />
        break
      case "product-review-quick-list":
        Component = <ProductReviewQuickList article={article} element={element} />
        break
      case "product-review":
        Component = <ProductReview article={article} element={element} />
        break
      default:
        Component = null
    }

    return Component
  }

  return renderElement(element)
}

export default React.memo(Element)
